import Seo from "../seo/Seo";
import { pageMetadata } from "../seo/metadata";
import { pageSchema } from "../seo/schema";

import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts';
import FooterSection from "../components/sections/FooterSection";
import Navbar from '../components/Navbar';

export default function Blog() {
  const sortedPosts = [...blogPosts].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <>
      <Navbar />
    <main id="main-content" className="min-h-screen" style={{ background: 'var(--color-night)', color: 'var(--color-on-night)' }} aria-labelledby="blog-heading">
      <div className="blog-page pt-28 md:pt-36 pb-24 md:pb-32">
        <Seo metadata={pageMetadata.blog} structuredData={pageSchema(pageMetadata.blog, [{ name: "Home", path: "/" }, { name: "Blog", path: "/blog" }], "CollectionPage")} />

        <div className="container mx-auto px-4 sm:px-6">
          <header className="blog-masthead max-w-5xl mx-auto mb-16 md:mb-20">
            <p className="font-display font-bold uppercase mb-4" style={{ fontSize: 'var(--text-sm)', letterSpacing: 'var(--tracking-label)', color: 'var(--color-accent)' }}>
              Court-side reading
            </p>
            <h1 id="blog-heading" className="font-display font-bold uppercase max-w-4xl" style={{ fontSize: 'var(--text-display)', lineHeight: 'var(--lh-tight)' }}>
              Tennis &amp; padel.<br /><span style={{ color: 'var(--color-accent)' }}>Learn the game.</span>
            </h1>
            <p className="mt-6 text-lg md:text-xl max-w-2xl" style={{ color: 'var(--color-on-night-muted)', lineHeight: 'var(--lh-body)' }}>
              Current stories, scoring rules, match strategy and Apple Watch how-tos for players who would rather remember the rally than the score.
            </p>
          </header>

          <section className="grid md:grid-cols-2 xl:grid-cols-3 gap-5 max-w-6xl mx-auto" aria-label="Racketly articles">
            {sortedPosts.map((post, index) => (
              <article key={post.id} className="blog-card h-full">
                <Link to={`/blog/${post.slug}`} className="blog-card__surface flex flex-col h-full" aria-labelledby={`post-${post.id}`}>
                  {post.image && (
                    <div className="blog-card__image overflow-hidden">
                      <img
                        src={post.image}
                        width={post.imageWidth}
                        height={post.imageHeight}
                        decoding="async"
                        alt={post.imageAlt}
                        loading={index === 0 ? 'eager' : 'lazy'}
                        className="blog-card__image-main"
                        style={{ objectPosition: post.imagePosition || 'center' }}
                      />
                    </div>
                  )}
                  <div className="blog-card__number" aria-hidden="true">{String(index + 1).padStart(2, '0')}</div>
                  <div className="p-7 md:p-8 flex flex-col flex-1 relative">
                    <div className="flex items-center gap-3 mb-6">
                      <span className="font-display font-bold uppercase" style={{ color: 'var(--color-accent)', fontSize: 'var(--text-xs)', letterSpacing: 'var(--tracking-label)' }}>
                        {post.category}
                      </span>
                      <span aria-hidden="true" style={{ color: 'var(--color-night-rule)' }}>•</span>
                      <time dateTime={post.date} style={{ color: 'var(--color-on-night-muted)', fontSize: 'var(--text-sm)' }}>{post.date}</time>
                    </div>

                    <h2 id={`post-${post.id}`} className="font-display font-bold uppercase mb-4" style={{ color: 'var(--color-on-night)', fontSize: 'var(--text-2xl)', lineHeight: 'var(--lh-snug)' }}>
                      {post.title}
                    </h2>

                    <p className="mb-8" style={{ color: 'var(--color-on-night-muted)', lineHeight: 'var(--lh-body)' }}>
                      {post.excerpt}
                    </p>

                    <span className="blog-card__link mt-auto pt-5 flex items-center gap-2 font-display font-bold uppercase" style={{ fontSize: 'var(--text-sm)', letterSpacing: 'var(--tracking-label)' }}>
                      <span>Read article</span>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </span>
                  </div>
                </Link>
              </article>
            ))}
          </section>
        </div>
      </div>
    </main>
      <FooterSection isDark={true} />
    </>
  );
}
